export enum Locale {
  deDE = 'de-de',
  esES = 'es-es',
  fiFI = 'fi-fi',
  nlNL = 'nl-nl',
  itIT = 'it-it',
  svSE = 'sv-se',
  nbNO = 'nb-no',
  ptPT = 'pt-pt',
  daDK = 'da-dk',
  enUS = 'en-us',
  frCA = 'fr-ca',
  esUS = 'es-us',
  enCA = 'en-ca',
  nlBE = 'nl-be',
  enIE = 'en-ie',
  frBE = 'fr-be',
  frFR = 'fr-fr',
  frCH = 'fr-ch',
  deAT = 'de-at',
  deCH = 'de-ch',
  itCH = 'it-ch',
  enAU = 'en-au',
  enNZ = 'en-nz',
  enSG = 'en-sg',
  enIN = 'en-in',
  enGB = 'en-gb',
}
